import { useContext } from "react"

import { StoreContext } from "./state-context"

export const useStore = () => useContext(StoreContext)
